(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746],{

/***/ 8:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(7116);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ ParadorFaq; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9536);
/* harmony import */ var _layout_FooterHotel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8078);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1914);








var __N_SSG = true;
function ParadorFaq(param) {
    var header = param.header, hotelBrands = param.hotelBrands, faqs = param.faqs;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), headerHeight1 = ref[0], setHeaderHeight = ref[1];
    var primaryColor = header.color_primary || "black";
    var unescapeHTML = function(str) {
        if (!str) return "";
        return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
    };
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: locale == "id" ? "FAQ | ".concat(header.name) : "FAQ | ".concat(header.name)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                getHeight: function(headerHeight) {
                    return setHeaderHeight(headerHeight);
                },
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                        as: "h1",
                        mb: 6,
                        textAlign: "center",
                        color: primaryColor,
                        children: locale === "id" ? "Pertanyaan yang Sering Diajukan" : "Frequently Asked Questions"
                    }),
                    faqs && faqs.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                        children: faqs.map(function(faq, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                mb: 8,
                                className: "white-space-enter",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: unescapeHTML((ref1 = locale === "id" ? faq.faq_id : faq.faq_en) !== null && ref1 !== void 0 ? ref1 : "")
                                    }
                                })
                            }, index);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                        textAlign: "center",
                        children: locale === "id" ? "Tidak ada FAQ ditemukan." : "No FAQs found."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_FooterHotel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: header.color_primary,
                color: header.color_secondary,
                logo: header.logo_light,
                hotelSlug: header.slug
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,4939,8078,9774,2888,179], function() { return __webpack_exec__(8); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);